
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.532 3.714a.75.75 0 01.53.919l-.776 2.898a.75.75 0 01-1.45-.388l.777-2.898a.75.75 0 01.919-.53zM1.25 7A.75.75 0 012 6.25h7.5a.75.75 0 01.586.281l3.774 4.719h.64A2.75 2.75 0 0117.25 14v4a.75.75 0 01-.75.75h-1.354a2.751 2.751 0 01-5.292 0H2a.75.75 0 010-1.5h7.854a2.751 2.751 0 015.293 0h.603V14a1.25 1.25 0 00-1.25-1.25H2a.75.75 0 010-1.5h4.75v-3.5H2A.75.75 0 011.25 7zm7 .75v3.5h3.69l-2.8-3.5h-.89zm4.25 9a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm5.186-7.464a.75.75 0 10.75 1.3l3.464-2a.75.75 0 00-.75-1.3l-3.464 2zm2.069 2.523a.75.75 0 10-.388 1.449l2.897.776a.75.75 0 00.389-1.449l-2.898-.776z"}})])
          )
        }
      }
    